import { useMenuStore } from "@/store/menu";
import request from "@/utils/request";

export const searchApi = (keyword) => request.get("/client/document/search", { params: { keyword, project_name: useMenuStore().projectName } }).then(res => (res.map(item => {
  return item
})))